<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<form name="ActionForm" class="form-horizontal" role="form" novalidate>
					<!--START OPTIONS-->
					<!--SchoolID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">School</label>
						<div class="col-sm-4 col-lg-3">
							<!-- <select class="form-control" name="SchoolID" (ngModelChange)="onSchoolChange($event)" [(ngModel)]="report.SchoolID">
                                <option value="" style="display:none;"></option>
                                <option *ngFor="let o of schoolList" [ngValue]="o.SchoolID">{{o.SchoolName}}</option>
                            </select> -->

							<caass-schoolselector [ShowAll]="false" [IsReport]="true" [ReportID]="223"> </caass-schoolselector>
						</div>
					</div>

					<!--SemesterID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Semester</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="SemesterID" [(ngModel)]="report.SemesterID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of SemesterList" [ngValue]="o.SemesterID">
									{{ o.Semester }}
								</option>
							</select>
						</div>
					</div>

					<!--PeriodID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Period</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="PeriodID" [(ngModel)]="report.PeriodID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of PeriodList" [ngValue]="o.PeriodID">
									{{ o.PeriodDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--MstrDate-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Month/Year</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="MstrDateID" [(ngModel)]="report.MstrDateID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of MstrDateList" [ngValue]="o.MonthDate">
									{{ o.MonthDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--InstructorID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Instructor</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="InstructorID" [(ngModel)]="report.InstructorID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of InstructorList" [ngValue]="o.Teacher_PersonID">
									{{ o.Instructor }}
								</option>
							</select>
						</div>
					</div>

					<!--MPDateStart-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Start Date</label>
						<div class="col-sm-4 col-lg-3">
							<p-calendar showIcon="true" showButtonBar="true" [(ngModel)]="report.MPDateStart" name="txtMPDateStart"></p-calendar>
						</div>
					</div>

					<!--MPDateEnd-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">End Date</label>
						<div class="col-sm-4 col-lg-3">
							<p-calendar showIcon="true" showButtonBar="true" [(ngModel)]="report.MPDateEnd" name="txtMPDateEnd"></p-calendar>
						</div>
					</div>

					<!--ORDERBY-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Sort By</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="ORDERBYID" [(ngModel)]="report.ORDERBYID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of ORDERBYList" [ngValue]="o.ORDERBYID">
									{{ o.ORDERBYName }}
								</option>
							</select>
						</div>
					</div>

					<!--ImageLogo-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Logo</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="ImageLogo" [(ngModel)]="report.ImageLogo">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of ImageLogoList" [ngValue]="o.ImageLibraryID">
									{{ o.LogoDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--File Type-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Output File Type</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="OutputTypeID" [(ngModel)]="OutputTypeID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of OutputTypeList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--Submit Form-->
					<div class="hr-line-dashed"></div>
					<div class="form-group">
						<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
							{{ errorMessage }}
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label"></label>
						<div class="col-md-4 col-lg-3">
							<div name="Saveing" *ngIf="isProcessing" class="alert alert-info">Processing.Please wait...</div>
							<button name="btnSaving" *ngIf="!isProcessing" class="btn btn-primary" type="button" (click)="Print()">Print</button>
							<button
								name="btnMerge"
								*ngIf="!isProcessing"
								class="btn btn-primary"
								style="margin-left: 5px"
								type="button"
								(click)="MergeToGroup()"
							>
								Merge to Group
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
